var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import format from 'date-fns/format';
export var GENDER_OPTIONS = [
    { label: 'Male', value: 'MALE', count: 0 },
    { label: 'Female', value: 'FEMALE' },
    { label: 'Others', value: 'OTHERS' }
];
export var MARITAL_STATUS_OPTIONS = [
    { label: 'Single', value: 'SINGLE' },
    { label: 'In a Relationship', value: 'IN_A_RELATION' },
    { label: 'Its Complicated', value: 'ITS_COMPLICATED' },
    { label: 'Married', value: 'MARRIED' },
    { label: 'Unmarried', value: 'UNMARRIED' },
    { label: 'Divorced', value: 'DIVORCED' }
];
export var getFormFieldNames = function (schema) {
    var fields = schema.fields;
    var names = Object.keys(fields).reduce(function (acc, field) {
        acc[field] = field;
        return acc;
    }, {});
    return names;
};
// export type CreateStudentForm = yup.InferType<typeof createStudentSchema>;
// type Required<T> = { [K in keyof T]: boolean | undefined };
// const validate = makeValidate(createStudentSchema);
// const formNames = getFormFieldNames(createStudentSchema);
// const required: Required<CreateStudentForm> = makeRequired(createStudentSchema);
//
// export const DUMMY_FORM_SCHEMA = {
//   className: 'grid grid-cols-2 gap-x-[8px] gap-y-[8px]',
//   // sx?: object;
//   // editEnabled: true,
//   editable: true,
//   // validations?: any;
//   secondaryButtonText: 'Cancel',
//   inputs: [
//     {
//       name: formNames.firstName,
//       required: required.firstName,
//       label: 'Given Name',
//       subInputs: [
//         {
//           name: formNames.firstName,
//           required: required.firstName,
//           label: 'Given Name 1',
//           placeholder: 'Enter Given Name',
//           type: 'text',
//           externalLabel: true,
//           className: 'col-span',
//           componentType: 'input',
//           editable: true,
//           maxLength: 10,
//           size: 'mini'
//         }
//       ]
//     },
//     {
//       name: formNames.lastName,
//       required: required.lastName,
//       label: 'Last Name',
//       placeholder: 'Enter Last Name',
//       type: 'text',
//       externalLabel: true,
//       className: 'col-span-2',
//       componentType: 'input',
//       editable: true
//     },
//     {
//       name: formNames.cspName,
//       required: required.cspName,
//       label: 'CSP Name',
//       placeholder: 'Enter CSP Name',
//       type: 'text',
//       externalLabel: true,
//       className: 'col-span-2',
//       componentType: 'input',
//       editable: true
//     },
//     {
//       name: formNames.contactNumber,
//       required: required.contactNumber,
//       label: 'Mobile Number',
//       placeholder: 'Enter mobile number',
//       externalLabel: true,
//       componentType: 'phone',
//       className: 'col-span-2',
//       editable: true
//     },
//     {
//       name: formNames.email,
//       required: required.email,
//       label: 'Email ID',
//       placeholder: 'Enter a valid email ID',
//       type: 'email',
//       externalLabel: true,
//       className: 'col-span-2',
//       componentType: 'input',
//       editable: true
//     },
//     {
//       name: formNames.dob,
//       required: required.dob,
//       label: 'Date of Birth',
//       type: 'date',
//       externalLabel: true,
//       componentType: 'input',
//       editable: true,
//       minDateDiff: -1
//     },
//     {
//       name: formNames.gender,
//       required: required.gender,
//       label: 'Gender',
//       externalLabel: true,
//       componentType: 'select',
//       editable: true,
//       options: GENDER_OPTIONS,
//       placeholder: 'Student Gender',
//       multiple: false
//     },
//     {
//       name: formNames.maritalStatus,
//       required: required.maritalStatus,
//       label: 'Marital Status',
//       type: 'text',
//       externalLabel: true,
//       className: 'col-span-2',
//       componentType: 'select',
//       editable: true,
//       options: MARITAL_STATUS_OPTIONS,
//       placeholder: 'Student Marital Status',
//       multiple: true,
//       menuPlacement: 'top'
//     }
//   ]
// };
// export const MY_FORM_SCHEMA = {
//   className: 'lfc-grid lfc-grid-cols-2 lfc-gap-2',
//   // sx?: object;
//   // editEnabled: true,
//   editable: true,
//   // validations?: any;
//   inputs: [
//     {
//           name: formNames.firstName,
//           required: required.firstName,
//           placeholder: 'Enter Given Name',
//           type: 'text',
//           label: 'name',
//           externalLabel: true,
//           className: 'lfc-col-span-2',
//           componentType: 'input',
//           editable: true,
//         },
//     {
//       name: formNames.lastName,
//       required: required.lastName,
//       label: 'Last Name',
//       placeholder: 'Enter Last Name',
//       type: 'text',
//       externalLabel: true,
//       className: '',
//       componentType: 'input',
//       editable: true
//     },
//     {
//       name: formNames.lastName,
//       required: required.lastName,
//       label: 'middlet Name',
//       placeholder: 'Enter Last Name',
//       type: 'text',
//       externalLabel: true,
//       className: '',
//       componentType: 'input',
//       editable: true
//     },
//     {
//       name: formNames.lastName,
//       required: required.lastName,
//       label: 'maonlet Name',
//       placeholder: 'Enter Last Name',
//       type: 'text',
//       externalLabel: true,
//       className: '',
//       componentType: 'input',
//       editable: true
//     },
//     {
//       name: `axio`,
//       required: false,
//       label: 'Additional Exam Score',
//       placeholder: 'Score',
//       type: 'number',
//       externalLabel: true,
//       className: 'col-span-2',
//       componentType: 'input',
//       editable: true
//     }
//   ]
// };
export var monthArr = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
export var getIntakeOptions = function () {
    var e_1, _a;
    var currentYear = Number(format(new Date(), 'yyyy'));
    var intakeOptions = [];
    for (var year = currentYear - 2; year < currentYear + 3; year++) {
        var options = [];
        try {
            for (var monthArr_1 = (e_1 = void 0, __values(monthArr)), monthArr_1_1 = monthArr_1.next(); !monthArr_1_1.done; monthArr_1_1 = monthArr_1.next()) {
                var month = monthArr_1_1.value;
                options.push({
                    label: "".concat(month, " ").concat(year),
                    value: "".concat(month.toUpperCase(), "_").concat(year)
                });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (monthArr_1_1 && !monthArr_1_1.done && (_a = monthArr_1.return)) _a.call(monthArr_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        intakeOptions.push.apply(intakeOptions, __spreadArray([], __read(__spreadArray([], __read(options), false)), false));
    }
    return intakeOptions;
};
export var applicationTypes = [
    {
        label: 'Agent Portal',
        value: 'AGENT_PORTAL'
    },
    {
        label: 'Online Application',
        value: 'ONLINE_APPLICATION'
    },
    {
        label: 'Third Party Application',
        value: 'THIRD_PARTY_APPLICATION'
    },
    {
        label: 'Paper Based Application',
        value: 'PAPER_BASED_APPLICATION'
    },
    {
        label: 'Email',
        value: 'EMAIL'
    },
    {
        label: 'To be filed by Geebee',
        value: 'TO_BE_FILED_BY_GEEBEE'
    }
];
export var mandatoryStudDocs = [
    {
        documentName: 'Education Documents',
        subDocument: [
            {
                label: '10th Marksheet'
            },
            {
                label: '12th Marksheet'
            },
            {
                label: 'Highest Degree Certificates and Marksheets'
            }
        ]
    },
    {
        documentName: 'Work Experience Documents',
        subDocument: [
            {
                label: 'Resume'
            },
            {
                label: 'Work Experience'
            },
            {
                label: 'LOR'
            }
        ]
    },
    {
        documentName: 'English Exam Scores',
        subDocument: [
            {
                label: 'English Exam Scorecard'
            }
        ]
    },
    {
        documentName: 'Other Documents',
        subDocument: [
            {
                label: 'Consolidated Passport'
            },
            {
                label: 'GRE/GMAT Scorecards'
            }
        ]
    }
];
export var CASFilingData = {
    universityId: 90,
    preVisaDocumentUploadDestination: 'SEND_MAIL_TO_AGGREGATOR_WITH_DOCS',
    preVisaDocumentReceivedBy: 'STUDENT_ON_MAIL',
    preCasQuestionnaireRequired: false,
    preCasInterviewRequired: true,
    casShieldRequired: true,
    kiraInterviewRequiredForCas: false,
    paymentMadeDocumentRequired: true,
    documentRequiredForPreVisa: '["Financial Document", "Unconditional Offer Letter", "Unconditional Offer Letter", "Unconditional Offer Letter", "Unconditional Offer Letter", "Unconditional Offer Letter", "Unconditional Offer Letter", "Unconditional Offer Letter", "Unconditional Offer Letter", "Unconditional Offer Letter", "Unconditional Offer Letter", "Unconditional Offer Letter"]'
};
//# sourceMappingURL=dummyConstants.js.map